import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

/**
 * 日本の携帯電話番号を検証し、Cognitoへ渡すE.164形式へ正規化する。
 * 番号の実在や所有者までは検証できないため、最終確認にはSMS OTPを使用する。
 */
export const normalizeJapaneseMobilePhoneNumber = (
    value: string
): string | null => {
    const phoneNumber = parsePhoneNumberFromString(value, 'JP');

    if (
        !phoneNumber ||
        phoneNumber.country !== 'JP' ||
        !phoneNumber.isValid() ||
        phoneNumber.getType() !== 'MOBILE'
    ) {
        return null;
    }

    return phoneNumber.number;
};
